export default __webpack_public_path__ + "images/pink-50.png";